import rpcAuth from './rpc/rpcAuth';

/**
 * Get announcements
 * @param company - Optional company parameter
 * Now uses RPC endpoint
 */
export async function getAnnouncements(company?: string) {
  const result = await rpcAuth.getAnnouncements(company);
  return result; // Returns { announcements, dismissed }
}

/**
 * Dismiss an announcement
 * @param id - Announcement ID
 * @param company - Optional company parameter
 * Now uses RPC endpoint
 */
export async function dismissAnnouncement(id: string, company?: string) {
  await rpcAuth.dismissAnnouncement(id, company);
}

